import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { pushRoute, setCurrentRoute } from 'src/redux/slices/routeHistory';
import { AppState } from 'src/redux/store';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';

const RouteHistory = () => {
  const {
    basePath, asPath, events, isReady,
  } = useRouter();
  const dispatch = useAppDispatch();
  const currentRoute = useAppSelector(({ routeHistory }: AppState) => routeHistory.currentRoute);

  useEffect(() => {
    const handleRouteChange = (url: string, { shallow }: { shallow: boolean }) => {
      if (shallow) {
        dispatch(setCurrentRoute({ route: url.slice(basePath.length) }));
      } else {
        dispatch(pushRoute({ route: url.slice(basePath.length) }));
      }
    };
    events.on('routeChangeStart', handleRouteChange);

    return () => {
      events.off('routeChangeStart', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    if (isReady && !currentRoute) {
      dispatch(pushRoute({ route: asPath }));
    }
  }, [isReady]);

  return null;
};
export default RouteHistory;
